export default __webpack_public_path__ + "static/media/qingpi_h5mgr-hover.d85bd433.svg";